import store from '@/store';
import { Cache } from 'aws-amplify';
import { executeApi } from '@/assets/js/aws/appsync';
import { usersByLoginID } from '@/graphql/queries';
import { AUTH_EXPIRATION_DAYS } from '@/assets/js/const';
/**
 * Amplify Cacheへユーザー情報（担当者マスタ）をセット
 * @param {*} loginId
 */
export async function setUserData(loginId) {
  try {
    // console.log(`setUserData`);
    // 検索条件
    let condition = { LoginID: loginId, filter: { IsDeleted: { eq: 0 } } };

    // データ取得
    const result = await executeApi(usersByLoginID, condition);
    // console.info({ result });
    // 結果判定
    if (result?.data?.usersByLoginID?.items[0]) {
      // データを取得できた場合
      const userData = result.data.usersByLoginID.items[0];
      // 取得結果を格納
      // console.info('result.data.usersByLoginID', userData);

      store.commit('setStateUser', userData);

      let date = new Date();
      // const.jsで定義した保持日数をセット
      date.setDate(date.getDate() + AUTH_EXPIRATION_DAYS);
      Cache.setItem('user', userData, { expires: date.getTime() });
      return true;
    } else {
      // データを取得できなかった場合
      // ログ出力
      // addLog('WARN', {
      //   errorType: MSG.WARN["001"],
      //   message: MSG.WARN["001"],
      //   errorMessage: `${loginId}のレコードが担当者マスタに存在しませんでした`,
      // })
      return false;
    }
  } catch (error) {
    // 異常系操作ログの登録
    // addLog('ERROR', {
    //   errorType: MSG.ERROR["001"],
    //   message: MSG.ERROR["001"],
    //   errorMessage: error.message,
    // })
    console.log('ERROR : error = ' + JSON.stringify(error));
    return false;
  }
}
